<template>
  <div class="head">
    <div class="head-body flex-between">
      <div class="phone"><i class="icon"></i>客服热线电话：010-57168135</div>
      <div>
        <!-- <el-input
          placeholder="找课"
          size="small"
          suffix-icon="el-icon-search"
          v-model="form.search"
          class="search-input"
        >
        </el-input> -->
      </div>

      <div v-if="user.role === 'student'">
        <!-- <el-link href="https://www.canpoint.net/user/level/level" :underline="false" class="sign">签到有奖励>></el-link> -->
        <!-- <el-link :underline="false" class="msg">消息</el-link> -->
        <el-link :underline="false" @click="onGoUser"
          >{{ userLabel }}{{ user.u_account }}</el-link
        >
        <el-link :underline="false" @click="onGoLogin" class="ml10">退出登录</el-link>
        <img :src="userHeadImg" class="top" @click="onGoUser" />
      </div>
      <div v-else-if="user.role === 'teacher'">
        <el-link :underline="false">{{ userLabel }}{{ user.u_account }}</el-link>
        <el-link :underline="false" @click="onGoLogin" class="ml10">退出登录</el-link>
        <img :src="userHeadImg" class="top" />
      </div>
      <div v-else-if="user.role === 'patriarch'">
        <el-link :underline="false">{{ userLabel }}{{ user.u_account }}</el-link>
        <el-link :underline="false" @click="onGoLogin" class="ml10">退出登录</el-link>
        <el-dropdown @command="onSelectSon">
          <span class="el-dropdown-link">
            <img :src="userHeadImg" class="top" />
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="item in user.son_list" :key="item.son_u_guid" :command="item" :disabled="item.son_u_guid==user.sonIng.son_u_guid">{{item.name}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  data: function() {
    return {
      form: {
        search: "",
        userHeadImg: "",
        userLabel: "",
      },
      userData: {},
      userLabel: "",
      userHeadImg: "",
    };
  },
  computed: {
    ...mapState(["user"]),
  },
  created() {
    if (!this.user.u_guid) {
      this.getUserInfo();
    } else {
      this.userHeadImg =
        this.user.u_img ||
        "//imgs9.canpoint.net/avatar/avatar5.jpg?x-oss-process=image/resize,m_lfit,h_50,w_50";
      if (this.user.role === "teacher") {
        this.userLabel = "教师";
      }
      if (this.user.role === "student") {
        this.userLabel = "学生";
      }
      if (this.user.role === "patriarch") {
        this.userLabel = "家长";
      }
      if(!this.user.sonIng && this.user.son_list.length >0){
        this.USER_SIGNIN(Object.assign(this.user,{sonIng: this.user.son_list[0]}));
      }
    }
  },
  methods: {
    ...mapActions(["USER_SIGNIN","USER_SIGNOUT","COURSE_STAGE_SUBJECT_OUT"]),
    getUserInfo() {
      this.getRequest("/wenjiaoopne/kc/user/getUser")
        .then((result) => {
          if (!result.data.u_guid || result.error_code > 0) {
            return false;
          }
          let token = this.user.token;
          let data = result.data;
          this.userData = {
            token: token,
            u_guid: data.u_guid,
            u_img: data.u_img,
            role: data.role,
            u_nickname: data.u_name
          };
          this.USER_SIGNIN(this.userData);
          this.userLabel = data.roleName;
          this.userHeadImg =
            data.u_img ||
            "//imgs9.canpoint.net/avatar/avatar5.jpg?x-oss-process=image/resize,m_lfit,h_50,w_50";
        })
        .catch(() => {
          this.loading.close();
        });
    },
    onGoUser() {
      this.path = this.$route.path;
      if (this.path === "/user") {
        return false;
      }
      this.$router.push("/user");
    },
    onGoLogin(){
      this.COURSE_STAGE_SUBJECT_OUT();
      this.USER_SIGNOUT();
      this.$router.push("/login");
    },
    onSelectSon(item){
      this.USER_SIGNIN(Object.assign(this.user,{sonIng: item}));
    },
  },
};
</script>

<style scoped>
.head {
  width: 100%;
  min-width: 1195px;
  background-color: #f3f1f1;
}
.head .phone {
  color: #666;
}
.head .head-body {
  width: 1195px;
  margin: 0 auto;
  height: inherit;
  line-height: 40px;
  font-size: 14px;
}
.head .search-input {
  width: 336px;
}
.head .icon {
  display: inline-block;
  width: 14px;
  height: 14px;
  background: url(https://www.canpoint.net//Template/style1/style_img/v4_img/hd_icon.png)
    no-repeat 0 0;
  margin-right: 5px;
  vertical-align: middle;
}
.head .sign {
  color: #02a4ef;
  margin-right: 20px;
}
.head .msg {
  margin: 0 50px 0 30px;
}
.head .top {
  width: 28px;
  height: 28px;
  cursor: pointer;
  border-radius: 50%;
  margin-left: 10px;
  border-color: antiquewhite;
  vertical-align: middle;
}
</style>
